var UpdateOptions;
(function (UpdateOptions) {
    UpdateOptions["CUSTOM"] = "custom";
    UpdateOptions["PRODUCT"] = "product";
    UpdateOptions["REWARD"] = "reward";
})(UpdateOptions || (UpdateOptions = {}));
export default UpdateOptions;
